import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { server, getFilledCollection, Auth } from "redux-server-connection";
import urls from "../../reducers/urls";

import Render from "./Render";

class SuperheroeCambiar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedName: props.avatars.length ? props.avatars[0].name : "0"
    };
  }

  componentWillMount() {
    if (typeof window !== "undefined") {
      this.props.getAvatars();
    }
  }

  componentWillReceiveProps(props) {
    if (
      this.state.selectedName === "0" &&
      props.avatars &&
      props.avatars.length
    ) {
      this.setState({ selectedName: props.avatars[0].name });
    }
  }

  onChange(position) {
    if (this.props.avatars[position]) {
      this.setState(state => {
        state.selectedName = this.props.avatars[position].name;
        return state;
      });
    }
  }
  
  onSubmit() {
    let selected = this.state.selectedName;
    if (selected === "0") {
      selected = this.props.avatars[0].name;
    }

    this.props.selectAvatar(this.state.selectedName).then(res => {
      if (res.ok) {
        const user = Auth.getUser();
        user.avatar = this.props.avatars.find(
          avatar =>
            avatar.name === this.state.selectedName &&
            avatar.level === user.level
        );
        Auth.setUser(user);
        this.props.history.push("/dashboard");
      }
    });
  }

  render() {
    return (
      <Render
        {...this.props}
        onChange={this.onChange.bind(this)}
        onSubmit={this.onSubmit.bind(this)}
      />
    );
  }
}

const mapStateToProps = state => {
  const user = Auth.getUser();
  return {
    avatars: getFilledCollection(state.avatars, urls.avatars.list).filter(
      avatar => avatar.name !== "0" && avatar.level === user.level
    )
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    getAvatars: () => dispatch(server.get(urls.avatars.list, "AVATARS")),
    selectAvatar: (name, callback) =>
      dispatch(server.post(urls.users.avatar("me"), "AVATARS", { name }))
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SuperheroeCambiar)
);



// WEBPACK FOOTER //
// ./src/pages/SuperheroeCambiar/index.js